// Custom barn + fence icon (line-art, inherits color via currentColor).
export const FarmIcon = ({ className = "" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* Barn roof (wide) */}
    <path d="M3.5 10 L12 4 L20.5 10" />
    {/* Barn walls */}
    <path d="M5.5 10 V17.5" />
    <path d="M18.5 10 V17.5" />
    {/* Barn door */}
    <path d="M9.5 17.5 V12 H14.5 V17.5" />
    {/* Fence rails */}
    <path d="M2.5 20 H21.5" />
    <path d="M2.5 22.5 H21.5" />
    {/* Fence posts */}
    <path d="M5 19 V23" />
    <path d="M9 19 V23" />
    <path d="M12 19 V23" />
    <path d="M15 19 V23" />
    <path d="M19 19 V23" />
  </svg>
);

export default FarmIcon;
